<template>
  <div class="search-container LKRoadmapsFeedFilters">
    <LkSearchInput
      :value="value.search"
      :loading="isLoading"
      placeholder="Поиск по названию карты"
      @submit="filterSearch"
    />
    <div class="filter-container">
      <div class="filter LKRoadmapsFeedFilters__filter">
        <FilterYear :years="years" @submit="filterYear" />
      </div>

      <div
        v-if="isCurator || isCoordinator"
        class="filter LKRoadmapsFeedFilters__filter"
      >
        <FilterAte @submit="filterAte" />
      </div>

      <div class="filter LKRoadmapsFeedFilters__filter">
        <FilterStatus @submit="filterStatus" />
      </div>

      <div
        v-if="isCurator || isExpert"
        class="filter LKRoadmapsFeedFilters__filter"
      >
        <FilterExpertStatus @submit="filterExpertStatus" />
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { DEBOUNCE_TIMEOUT } from '@/helpers/enums/params'

import LkSearchInput from '@/components/lk/LkSearchInput.vue'
import FilterAte from './Filters/LKRoadmapsFeedFilterAte.vue'
import FilterStatus from './Filters/LKRoadmapsFeedFilterStatus.vue'
import FilterYear from './Filters/LKRoadmapsFeedFilterYear.vue'
import FilterExpertStatus from './Filters/LKRoadmapsFeedFilterExpertStatus.vue'

const createDefaultForm = () => ({
  search: '',
  status: null,
})

export default {
  name: 'LKRoadmapsFeedFilters',
  components: {
    LkSearchInput,
    FilterAte,
    FilterStatus,
    FilterYear,
    FilterExpertStatus,
  },
  props: {
    value: {
      type: Object,
      default: createDefaultForm,
    },
    isCurator: Boolean,
    isExpert: Boolean,
    isCoordinator: Boolean,
    years: Array,
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
    },
    filter: debounce(function filter(v) {
      const { value } = this

      this.$emit('input', { ...value, ...v })
    }, DEBOUNCE_TIMEOUT),
    filterSearch(v) {
      this.filter({ search: v })
    },
    filterAte({ regions, municipalities, schools }) {
      this.filter({
        region_ids: regions.map(({ id }) => id).join(','),
        municipality_ids: municipalities.map(({ id }) => id).join(','),
        school_ids: schools.map(({ id }) => id).join(','),
      })
    },
    filterStatus(v) {
      this.filter({ is_confirmed: v })
    },
    filterExpertStatus(v) {
      this.filter({ expert_status: v })
    },
    filterYear(v) {
      this.filter({ year: v })
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedFilters {
  &__filter {
    @media screen and (max-width: 767px) {
      width: 100%;
      margin-right: 0 !important;
    }
  }
}
</style>
